import { useRef, useState } from 'react';

import { CheckboxItem, ListCheckbox, Menu, MultiSelect } from '@scaleaq/scaleui';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

interface MultiselectProps<T extends FieldValues> {
  options: CheckboxItem[];
  label: string;
  disabled?: boolean;
  control: Control<T>;
  valueName: Path<T>;
}

export const ControlledMultiSelect = <T extends FieldValues>({
  options,
  label,
  disabled,
  control,
  valueName,
}: MultiselectProps<T>) => {
  const [multiselectOpen, setMultiselectOpen] = useState(false);

  const multiSelectRef = useRef<HTMLDivElement>(null);

  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  return (
    <Controller
      control={control}
      name={valueName}
      render={({ field: { onChange, value } }) => (
        <Menu
          anchorEl={multiSelectRef}
          open={multiselectOpen}
          onClose={() => setMultiselectOpen(false)}
          menuElement={
            <ListCheckbox
              toggleAll
              ids={selectedIds}
              onChange={ids => {
                setSelectedIds(ids);
                onChange(ids.join(','));
              }}
              items={options}
            />
          }
        >
          <MultiSelect
            ref={multiSelectRef}
            open={multiselectOpen}
            setOpen={setMultiselectOpen}
            label={label}
            value={options
              ?.filter(o => value?.includes(o.id))
              ?.map(ov => ov.label)
              ?.join(', ')}
            width='100%'
            disabled={disabled}
          />
        </Menu>
      )}
    />
  );
};
